import React from 'react';
import classNames from 'clsx';

import EditButton from 'app/components/EditButton';
import { ButtonLabelEnum } from 'app/shared/enums';

import { CarRegistrationNumberEditButtonProps } from './CarRegistrationNumberEditButton.interfaces';
import { useStyles } from './CarRegistrationNumberEditButton.styles';

export default function CarRegistrationNumberEditButton(
  props: CarRegistrationNumberEditButtonProps
) {
  const { label = '', onClick, responsive } = props;

  const classes = useStyles(props)();

  return (
    <EditButton onClick={onClick} className={classes.button}>
      <span className={classes.euroband} />
      <span className={classNames({ [classes.labelEmpty]: !label })}>
        {label ? (
          <>
            {responsive && (
              <span className={classes.prefix}>
                {ButtonLabelEnum.RegistrationNumber}{' '}
              </span>
            )}
            <span>{label}</span>
          </>
        ) : (
          <>{ButtonLabelEnum.NoRegistrationNumber}</>
        )}
      </span>
    </EditButton>
  );
}
